var map = {
	"./level1/1.jpg": 36,
	"./level1/2.jpg": 37,
	"./level1/3.jpg": 38,
	"./level1/4.jpg": 39,
	"./level1/5.jpg": 40,
	"./level1/6.jpg": 41,
	"./level2/1.jpg": 42,
	"./level2/2.jpg": 43,
	"./level2/3.jpg": 44,
	"./level2/4.jpg": 45,
	"./level2/5.jpg": 46,
	"./level2/6.jpg": 47,
	"./level3/1.jpg": 48,
	"./level3/1a.jpg": 49,
	"./level3/2.jpg": 50,
	"./level3/3.jpg": 51,
	"./level3/4.jpg": 52,
	"./level3/5.jpg": 53,
	"./level3/6.jpg": 54,
	"./level4/1.jpg": 55,
	"./level4/2.jpg": 56,
	"./level4/3.jpg": 57,
	"./level4/4.jpg": 58,
	"./level4/5.jpg": 59,
	"./level4/6.jpg": 60,
	"./level5/1.jpg": 61,
	"./level5/2.jpg": 62,
	"./level5/3.jpg": 63,
	"./level5/4.jpg": 64,
	"./level5/5.jpg": 65,
	"./level5/6.jpg": 66,
	"./level6/1.jpg": 67,
	"./level6/2.jpg": 68,
	"./level6/3.jpg": 69,
	"./level6/4.jpg": 70,
	"./level6/5.jpg": 71,
	"./level6/6.jpg": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;